const messages = [
    "Hi! I'm Angstel, the Anxiety Monster! Click me to display a different message.",
    "When you see a (continue) is because I have more things to say! (continue)",
    "I talk a lot, I know...sorry about that. It's my Social Anxiey. (continue)",
    "Hey! I'm glad you're still here! Maybe we can be friends? (continue)",
    "You know what they say: you should befriend your demons... (continue)",
    "Good! Now that we're friends, let me tell you a little secret. (continue)",
    "I'm actually not a bad monster, I'm just what you make of me. (continue)",
    "Really! You have all the power in this relationship! (continue)",
    "So let me be your personal cheerleader today! (continue)",
    "You're doing great! If you want another message, just click me!",
    "Every effort you make counts.",
    "You can do it!",
    "You are stronger than you think.",
    "Every day is a second chance.", 
    "You've got this!",
    "The best way out is always through.",
    "Repeat after me: I. Can. Do. This.",
    "Every moment is a fresh begining.",
    "Keep up the good work!",
    "Life's a journey, not a race.",
    "Take a break, you deserve it.",
    "You're doing a great job!",
    "I belive in you!",
    "Whoa! Amazing!",
    "You can do anything you set your mind to!",
    "You're rocking it!",
    "This is my last message, but if you click me I'll start over!"
]

export default messages;